// ============================================================
// NXTPLATE — SITE CONFIG
// Edit contact details, dates and brand constants here.
// Every page (Support, Privacy, Terms) reads from this file.
// ============================================================

export const SITE = {
  name: "NXTPlate",
  slogan: "Your Next Plate, Already Planned",
  domain: "thenxtplate.com",
  supportEmail: "support@thenxtplate.com",
  legalLastUpdated: "July 2026",
  appStoreUrl: "https://apps.apple.com/us/app/nxtplate/id6791683115",
  launchNote: "Now on iOS",
};
